/**
 * @author Fernando FH
 */

 import PRM from "@/core/PermissionConstants";
 import  RouteConstants  from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.COLPOSCOPY_HISTORY.path,
  name: RouteConstants.COLPOSCOPY_HISTORY.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/ColposcopyHistoryService"),
    table: () =>  import("@/app/components/colposcopy/history/ColposcopyHistoryTable"),
    form: () =>  import("@/app/components/colposcopy/history/ColposcopyHistoryForm"),
    header: {
      icono: "mdi-crosshairs-gps",
      texto: "Historial de atenciones | Colposcopia",
      textNew: "Atender  | Colposcopia",
      textEdit: "Editar  | Colposcopia",
      textView: "Visualizar  | Colposcopia"
    },
    prm: PRM.MODULE_COLPOSCOPY_HISTORY,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    labelDate: "Seleccione fecha",
    namePDF: "Colposcopia"
  },
};
